<template>
	<div>
		<van-tabbar v-model="activeTab" route class="tabbar-container">
			<van-tabbar-item replace to="/home" icon="wap-home-o">Home</van-tabbar-item>
			<van-tabbar-item replace to="/menu" icon="bars">Menu</van-tabbar-item>
			<van-tabbar-item replace to="/me" icon="user-circle-o">Profile</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
// @ is an alias to /src
export default {
	components: {},
	data() {
		return {
			activeTab: 0
		}
	}
}
</script>

<style scoped lang="less">
.tabbar-container {
	margin: 0px;
	padding: 0px;
	border: 0px;
}
</style>
